/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Title, Tip, Icon, Switch, Note, TextField } from '@insticator/insticator-ui'; // iui-material
import ImageUpload from 'material/imageupload/imageupload_container';
import ColorPicker from 'material/embeds/colorpicker/colorpicker';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/addons/addontypes/emailcollection/emailcollectionproperties/emailcollectionproperties_styles';



/* ========== ~~~~~~~~~~ EMBED PROPERTIES ~~~~~~~~~~ ========== */
class EmailCollectionProperties extends Component {
    constructor(props) {
        super(props);
        this.state = { partnerurl: true };
    }

    setPartnerLogoPreview = (imageFile) => {
        this.props.setCustomEmailCollectionPreviewImage(imageFile);
    };
    setPartnerLogoSrc = (imageFile) => {
        // this.props.setPartnerLogoSrc(URL.createObjectURL(imageFile));
        this.props.uploadEmailCollectionBackgroundImage(this.props.accountUUID, imageFile);
    };

    render() {
        return (
            <div className={`emailcollectionproperties ${this.props.classes.emailcollectionproperties}`}>
                <div className={`property`}>
                    <div className={`proptitle`}>
                        <h5>Publisher name</h5>
                    </div>
                    <div className={`propdetails`}>
                        <div className={`propdetail link`}>
                            <TextField
                                type={`name`}
                                name={`publishername`}
                                valid={this.props.publisherName.valid}
                                placeholder={`ex: Insticator`}
                                handleChange={(e) => this.props.setUniqueEmailCollectionProperty('publisherName', e.target.value)}
                                value={this.props.publisherName.value}
                                required
                            />
                        </div>
                    </div>
                </div>
                <div className={`property`}>
                    <div className={`proptitle`}>
                        <h5>Link to Publisher's Site Privacy Policy</h5>
                    </div>
                    <div className={`propdetails`}>
                        <div className={`propdetail link`}>
                            <TextField
                                type={`url`}
                                name={`storyURL`}
                                valid={this.props.publisherPrivacyPolicyURL.valid}
                                placeholder={`ex http://www.inst.com`}
                                value={this.props.publisherPrivacyPolicyURL.value}
                                handleChange={(e) => this.props.setUniqueEmailCollectionProperty('publisherPrivacyPolicyURL', e.target.value)}
                                icon={<Icon name={`link`} />}
                                required
                            />
                        </div>
                    </div>
                </div>
                <div className={`property brandcolor`}>
                    <div className={`proptitle`}>
                        <h5>Background color:</h5>
                    </div>
                    <div className={`propdetails`}>
                        <div className={`propdetail color`}>
                            <ColorPicker
                                color={this.props.backgroundColor.value}
                                processColorUpdate={(color) => this.props.setUniqueEmailCollectionProperty('backgroundColor', color)} />
                        </div>
                    </div>
                </div>
                <div className={`property`}>
                    <div className={`proptitle`}>
                        <h5>Background image</h5>
                    </div>
                    <div className={`propdetails`}>
                        <div className={`propdetail image`}>
                            <ImageUpload
                                previewImage={this.setPartnerLogoPreview}
                                processImage={this.setPartnerLogoSrc}
                                cta={true}
                                uploadingCustomImage={this.props.settingCustomEmailCollectionImage}
                                imageSize={{ width: '150px', height: 'auto' }}
                                cropSize={{ width: 146, height: 178 }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmailCollectionProperties);
